const initialUser = {
  childName: undefined,
  uid: undefined,
  energyLevel: undefined,
  fuelLevel: undefined,
  healthLevel: undefined,
  schoolId: undefined,
  schoolName: undefined,
  parent: { name: undefined, email: undefined },
  isAdmin: undefined,
  avatar: undefined,
  roundsPlayed: [],
};

export default initialUser;
